<dw-ui-dialog-box
  [title]="dialogBoxTitle"
  [saveDisabled]="!canSave()"
  [saveBusy]="isSaving()"
  [saveLabel]="'Doc::SupplierReceipt:Validate' | abpLocalization"
  (saveFn)="save()"
>
  <div class="form-check form-switch mb-2">
    <input
      class="form-check-input"
      type="checkbox"
      role="switch"
      id="printLabel"
      [ngModel]="printLabel"
      (ngModelChange)="onPrintLabelChange($event)"
    />
    <label for="printLabel" class="form-check-label text-primary">
      {{ 'Doc::SupplierReceipt:PrintLabel' | abpLocalization }}
    </label>
  </div>

  <div class="receipt-grid-wrapper">
    <document-lines-editor
      #lineGrid
      [columnDefs]="columnDefs"
      [rows]="lines"
      [onCellValueChanged]="onCellValueChanged"
      [treeData]="true"
      [getDataPath]="getDataPath"
      [chapterLineRole]="chapterLineRole"
      [getContextMenuItems]="getContextMenuItems"
      [pinnedBottomRowData]="pinnedBottomRowData"
      [rowClassRules]="rowClassRules"
      [onRowSelected]="onRowSelected"
      [isDialogBox]="true"
      [fillRemainingHeight]="false"
      [domLayout]="'autoHeight'"
      gridStateKey="supplierDeliveryNoteCreationGrid"
      [selectedLines]="selectedLines"
    >
    </document-lines-editor>
  </div>
</dw-ui-dialog-box>
